import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import s from './style.less';
import CreditCard from './components/creditCard';
import DB_CONST from '../../config/db_const';

Modal.setAppElement(document.body);

export default class Underfunded extends React.Component {
  static modalStyle = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
      zIndex: 1111,
    },
    content: {
      position: 'absolute',
      top: '0',
      left: '50%',
      transform: 'translate(-50%)',
      width: '100%',
      maxWidth: '1070px',
      bottom: '0',
      border: '1px solid #ccc',
      background: '#fff',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      borderRadius: '4px',
      outline: 'none',
      padding: '60px 305px',
    },
  };

  static propTypes = {
    debts: PropTypes.array,
    getDebts: PropTypes.func,
  };

  state = {
    open: this.props.debts.length > 0,
    payed: false,
  };

  componentWillReceiveProps = props => {
    if (props.debts.length > 0) {
      this.setState({
        open: true,
      });
    }
  };

  setPayed = () => this.setState({ payed: true });

  close = () => this.setState({ open: false });

  render() {
    if (this.state.payed) {
      return (
        <div>
          <Modal
            onRequestClose={this.close}
            isOpen={this.state.open}
            contentLabel="underfunded-payments"
            style={this.constructor.modalStyle}
          >
            <div className={s.root}>
              <h2>
                Thank you for your payment, please proceed to your booking
              </h2>
              <div className={s.submit} onClick={this.close}>
                Close
              </div>
            </div>
          </Modal>
        </div>
      );
    }

    const total = this.props.debts
      .reduce((prev, next) => prev + next.cost - next.paid, 0)
      .toFixed(2);
    const debt = this.props.debts && this.props.debts[0];
    return (
      <div>
        <Modal
          onRequestClose={this.close}
          isOpen={this.state.open}
          contentLabel="underfunded-payments"
          style={this.constructor.modalStyle}
        >
          <div className={s.root}>
            <h1 className={s.h1}>Your Plan is Underfunded for this Booking</h1>
            <div className={s.closeModal} onClick={this.close}>
              <Icon type="close-circle-o" />
            </div>
            {debt && (
              <div>
                <div>
                  <div>Booking Value</div>
                  <div className={s.gray}>
                    &pound;
                    {debt.cost.toFixed(2)}
                  </div>
                </div>
                <div>
                  <div>Plan Balance</div>
                  <div className={s.gray}>
                    &pound;
                    {debt.paid.toFixed(2)}
                  </div>
                </div>
                <div>
                  <div>Payment Required</div>
                  <div className={s.gray}>
                    &pound;
                    {(debt.cost - debt.paid).toFixed(2)}
                  </div>
                </div>
                <div className={s.right}>
                  <b>
                    Total: &pound;
                    {(debt.cost - debt.paid).toFixed(2)}
                  </b>
                </div>
              </div>
            )}
            <h2>Pay by card</h2>
            <br />
            <CreditCard
              amount={total}
              getDebts={this.props.getDebts}
              setPayed={this.setPayed}
            />
            <div>
              <b>Customer helpline:</b>
              <br />
              <a href={`call:${DB_CONST.customerHelpline}`}>
                {DB_CONST.customerHelpline}
              </a>
            </div>
            <br />
            <div>
              <b>Email: </b>
              <br />
              <a href="mailto:customercare@serviceplans.co.uk">
                customercare@serviceplans.co.uk
              </a>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
